import { Injectable, inject } from '@angular/core';
import {
  IConfigVecino,
  INuevoVecino,
  IQueryParam,
  IUpdateConfigVecino,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import { HttpApiAdminService } from '../../auxiliares/servicios/http-api.service';
import { saveAs } from 'file-saver';

/**
 * Operaciones de "vecinos" del panel admin. La identidad del vecino es el
 * ConfigVecino (`/configvecinos`); la colección `vecinos` está deprecada y
 * sus rutas de escritura (`PUT/DELETE /vecinos/:id`) devuelven 410.
 * El alta por admin sigue entrando por `POST /vecinos`, que hoy crea solo
 * el ConfigVecino.
 */
@Injectable({
  providedIn: 'root',
})
export class VecinosService {
  private http = inject(HttpApiAdminService);
  private helper = inject(HelperService);

  public exportar(queryParams?: IQueryParam): Promise<void> {
    return new Promise((resolve) => {
      const params = this.helper.getQueryParams(queryParams);

      // return this.httpClient.get(api + ruta, { headers, params, responseType: 'blob' }).pipe(catchError(this.parseErrorBlob));

      this.http
        .get(`/configvecinos/exportar`, { params, responseType: 'blob' })
        .subscribe(
          (response) => {
            try {
              const file = new File([response], 'export.xlsx');
              saveAs(file);
              resolve();
            } catch (error) {
              console.error(error);
              resolve();
            }
          },
          (error) => {
            console.error(error);
            resolve();
          },
        );
    });
  }

  /** Alta de vecino por admin: el backend crea solo el ConfigVecino. */
  public crear(dato: INuevoVecino): Observable<IConfigVecino> {
    return this.http.post(`/vecinos`, dato);
  }

  // configs

  /** Borra la config y limpia sus controles asociados (lo hace el backend). */
  public eliminarConfig(id: string): Observable<void> {
    return this.http.delete(`/configvecinos/${id}`);
  }

  /** Revoca las sesiones (tokens) del vecino identificado por su ConfigVecino. */
  public desloguearConfig(
    idConfigVecino: string,
  ): Observable<{ deleted: boolean }> {
    return this.http.delete(`/configvecinos/logout/${idConfigVecino}`);
  }

  public editarConfig(
    id: string,
    dato: IUpdateConfigVecino,
  ): Observable<IConfigVecino> {
    return this.http.put(`/configvecinos/${id}`, dato);
  }
}
